import type { ReactNode } from "react";
import { WebPullToRefresh } from "@/components/refresh/WebPullToRefresh";
import { useOptionalTabActivity } from "@/contexts/TabActivityContext";

interface PageRefreshBoundaryProps {
  onRefresh: () => Promise<void> | void;
  children: ReactNode;
  className?: string;
}

export function PageRefreshBoundary({
  onRefresh,
  children,
  className,
}: PageRefreshBoundaryProps) {
  const isActive = useOptionalTabActivity()?.isActive ?? true;

  return (
    <WebPullToRefresh onRefresh={onRefresh} className={className} active={isActive}>
      {children}
    </WebPullToRefresh>
  );
}
